/* ============================================================
   TAP TO BREW - Animation Controller
   ============================================================ */
(function() {
  'use strict';

  /* --- スクロールアニメーション Observer --- */
  if (typeof IntersectionObserver !== 'undefined') {
    var animObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          animObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll(
      '.ttb-anim-up, .ttb-anim-scale, .ttb-anim-left, .ttb-anim-right, ' +
      '.ttb-stagger, .ttb-gold-line, .ttb-photo-break__quote, ' +
      '.ttb-comparison, .ttb-reveal'
    ).forEach(function(el) {
      animObserver.observe(el);
    });
  }

  /* --- 数字カウントアップ --- */
  function animateCounters() {
    var counters = document.querySelectorAll('[data-ttb-count]');
    if (!counters.length) return;

    var counterObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var target = parseInt(el.getAttribute('data-ttb-count'), 10);
          var suffix = el.getAttribute('data-ttb-suffix') || '';
          var duration = 1500;
          var start = 0;
          var startTime = null;

          function step(timestamp) {
            if (!startTime) startTime = timestamp;
            var progress = Math.min((timestamp - startTime) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3); // easeOutCubic
            var current = Math.round(eased * target);
            el.textContent = current.toLocaleString() + suffix;

            if (progress < 1) {
              requestAnimationFrame(step);
            } else {
              el.classList.add('ttb-count-pulse');
            }
          }
          requestAnimationFrame(step);
          counterObserver.unobserve(el);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(function(el) { counterObserver.observe(el); });
  }
  animateCounters();

  /* --- パララックス（軽量版） --- */
  var parallaxEls = document.querySelectorAll('[data-ttb-parallax]');
  if (parallaxEls.length) {
    window.addEventListener('scroll', function() {
      var scrollY = window.scrollY;
      parallaxEls.forEach(function(el) {
        var speed = parseFloat(el.getAttribute('data-ttb-parallax')) || 0.3;
        var rect = el.getBoundingClientRect();
        var offset = (rect.top + scrollY - window.innerHeight / 2) * speed;
        el.style.transform = 'translateY(' + (-offset * 0.1) + 'px)';
      });
    }, { passive: true });
  }

  /* --- テキスト1文字ずつ表示（タイプライター風） --- */
  document.querySelectorAll('[data-ttb-typewriter]').forEach(function(el) {
    var text = el.textContent;
    el.textContent = '';
    el.style.visibility = 'visible';

    var typeObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var i = 0;
          var interval = setInterval(function() {
            el.textContent += text[i];
            i++;
            if (i >= text.length) clearInterval(interval);
          }, 40);
          typeObserver.unobserve(el);
        }
      });
    }, { threshold: 0.5 });
    typeObserver.observe(el);
  });

})();
